import { nanoId } from '@/helpers'
import invoices from '@/api/apiSferest/services/invoices'
import { apificateDate, formatNow } from '@/helpers/formatDate'

/**
 * Set File List
 * @param {Array} payload - Array with Files.
 */
export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    dispatch('empty').then(() => {
      commit('SET_ISTHEREFILES', !!payload.length)
      commit('SET_TODELETELIST', [])
      Promise.all([
        payload.map(file => dispatch('insertFile', file))
      ]).then(() => {
        resolve()
      }, (err) => {
        reject(err)
      })
    })
  })
}

export const insertFile = ({ commit, state }, value) => {
  return new Promise((resolve) => {
    let key = nanoId(8)
    commit('ADD_FILE', { key, value })
    resolve({ key, value })
  })
}

export const emptyForm = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_FILE_CREATION', formatNow())
    commit('SET_FILE_TYPE', '4')
    commit('SET_FILE_DESCRIPTION', undefined)
    commit('SET_FILE_SIZE', undefined)
    commit('SET_FILE_FILE', undefined)
    resolve()
  })
}

export const deleteFile = ({ commit, state }, key) => {
  return new Promise((resolve) => {
    let value = { ...state._[key] }
    commit('DELETE_FILE', key)
    resolve({ key, value })
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map(key => {
        return dispatch('deleteFile', key)
      })
    ])
    .then(() => {
      resolve()
    })
  })
}

export const toDeleteFiles = ({ commit, state }, key) => {
  return new Promise((resolve) => {
    let id = state._[key].id
    if (!id) {
      resolve()
      return
    }
    commit('ADD_TODELETELIST', id)
    resolve(id)
  })
}

// TODO USE magic numbers with FILEREADER
const defineMIME = name => {
  const EXTENSION = /\.[0-9a-z]+$/i
  let ext = EXTENSION.exec(name)
  switch (ext) {
    case 'jpg':
      return 'data:image/png;base64,'
    case 'gif':
      return 'data:image/gif;base64,'
    case 'pdf':
      return 'data:application/pdf;base64,'
    case 'xml':
      return 'data:application/xml;base64,'
    case 'zip':
      return 'application/zip;base64,'
    default:
      return 'data:text/plain;base64,'
  }
}

export const downloadFile = ({ commit, state }, body) => {
  return new Promise((resolve) => {
    var idI = body.id
    var key = body.key
    var idA = state._[key].id
    var _name = state._[key].name
    if (idA) {
      invoices.getAttachment(idI, idA).then((res) => {
        let dwn = res.data
        if (dwn && dwn.file) {
          var name = dwn.name ? dwn.name : _name
          var link = document.createElement('a')
          link.setAttribute('href', defineMIME(name) + encodeURIComponent(dwn.file))
          link.setAttribute('download', name)
          document.body.appendChild(link)
          link.click()
        }
      })
    } else {
      var name = _name
      var link = document.createElement('a')
      link.setAttribute('href', defineMIME(name) + encodeURIComponent(state._[key].file))
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    }
    resolve()
  })
}

export const save = ({ commit, state }, idI) => {
  return new Promise((resolve, reject) => {
    var list = Object.values(state._)
    Promise.all([
      ...state.toDeleteList.map(idA => {
        return invoices.deleteAttachments(idI, idA)
      }),
      ...list.filter(obj => !obj.id).map(x => {
        var params = {
          creation: apificateDate(x.creation),
          description: x.description,
          type: x.type,
          file: x.file,
          name: x.name
        }
        return invoices.postAttachments(idI, params)
      })
    ]).then(res => {
      commit('SET_TODELETELIST', [])
      resolve(res)
    }, err => {
      reject(new Error(err))
    })
  })
}

export const saveOne = ({ commit, state }, { idI, key }) => {
  return new Promise((resolve, reject) => {
    var file = state._[key]
    var params = {
      creation: apificateDate(file.creation),
      description: file.description,
      type: file.type,
      file: file.file,
      name: file.name
    }
    invoices.postAttachments(idI, params)
    .then((res) => {
      resolve()
    })
  })
}

export const deleteOne = ({ commit, state }, { idI, idA }) => {
  return new Promise((resolve, reject) => {
    invoices.deleteAttachments(idI, idA)
    .then(() => {
      commit('SET_TODELETELIST', [])
      resolve()
    })
  })
}
